import flagKeys from '@/constants/flagKeys';
import { Route } from '../route.model';

const Home = () => import('@/views/Home/Home.vue');

const home = new Route('/home', 'home', Home, {
  isResponsive: flagKeys.responsiveDashboard,
  requiresAuth: true,
  requiresBusiness: true,
  flag: flagKeys.homepage,
  navbar: {
    name: 'Home'
  },
  pageView: {
    eventLabel: 'Home'
  }
});

export { home };
export default home;
